// FEAT-056(#560): 라이선스 제품 목록 — 데이터만 둔다(import 없음).
// 제품 식별자(licenseAppId · packageIds · PC 활성화 localAppId)는 이 파일 밖에서 리터럴로 쓰지 않는다.
// PC 활성화가 없는 제품은 `pcActivation: null` 로 둔다.
// 새 제품은 이 목록에 항목을 추가한다.

export const LICENSE_PRODUCT_SMARTDENT = Object.freeze({
    key: 'smartdent',
    name: 'SMARTDent Standalone',
    // rayteams-license DDB 의 할당 레코드 _id
    licenseAppId: 'smartdent_standalone',
    // rayteams-product(-package) 의 상품 패키지 ID
    packageIds: Object.freeze(['9is32209-c37b-41fe-ac15-0c0yyy2db0xx']),
    // rayteams 측 localhost License Check API path segment (DDB _id 와 의미상 분리)
    pcActivation: Object.freeze({ localAppId: 'license-segmentation' }),
    // FEAT-049 RU 전용 redeem 주소(voucherRedeem.js)를 적용하는 제품
    ruRedeem: true,
});

// FEAT-060(#588): Surgical Guide. 식별자는 RAYTeams license-api.md 「Surgical Guide Voucher」 표 기준.
export const LICENSE_PRODUCT_SURGICALGUIDE = Object.freeze({
    key: 'surgicalguide',
    name: 'Surgical Guide',
    licenseAppId: 'surgicalguide_voucher',
    packageIds: Object.freeze(['sis26909-c37b-41fe-ac15-0c0xxx2db0qq']),
    pcActivation: null,
    // RU redeem 주소 미적용은 사용자 결정(2026-10-14)
    ruRedeem: false,
});

export const LICENSE_PRODUCTS = Object.freeze([LICENSE_PRODUCT_SMARTDENT, LICENSE_PRODUCT_SURGICALGUIDE]);

export const DEFAULT_LICENSE_PRODUCT = LICENSE_PRODUCT_SMARTDENT;
